export default __webpack_public_path__ + "static/media/DeveloperGuidelines_fetchorigin.e3eba93e.png";